import { render, staticRenderFns } from "./Step5.vue?vue&type=template&id=84ddce18&scoped=true&"
import script from "./Step5.vue?vue&type=script&lang=js&"
export * from "./Step5.vue?vue&type=script&lang=js&"
import style0 from "./Step5.vue?vue&type=style&index=0&id=84ddce18&prod&scoped=true&lang=css&"
import style1 from "./Step5.vue?vue&type=style&index=1&id=84ddce18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ddce18",
  null
  
)

export default component.exports